import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { Container, Content, Image, ErrorTitle as Title, Subtitle } from './common';
import NoDataFoundImage from '../../icons/no-data-found.svg';

const StyledContent = styled(Content)`
  max-width: 320px;
`;

export const NoDataFoundError = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Container>
      <StyledContent>
        <Image alt="Title" src={NoDataFoundImage} />
        <Title as="p" textType="subtitle1">
          {t('heatmaps:error-states.no-data-found.title')}
        </Title>
        <Subtitle as="p" textType="caption" textColor="text_light">
          {t('heatmaps:error-states.no-data-found.subtitle')}
        </Subtitle>
      </StyledContent>
    </Container>
  );
};
